import { render, staticRenderFns } from "./Mail.Detail.vue?vue&type=template&id=8d2eefb4&"
import script from "./Mail.Detail.vue?vue&type=script&lang=js&"
export * from "./Mail.Detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports